import React, { useMemo } from "react";
import { ReportView } from "model/Report";
import styled from "styled-components";
import Switch from "@material-ui/core/Switch";

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid #dadce0;
`;

const Item = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1 0 50%;
  box-sizing: border-box;
  border-bottom: 1px solid #dadce0;
  padding: 0 20px;

  &:nth-child(odd) {
    border-right: 1px solid #dadce0;
  }
`;

const Text = styled.p`
  font-size: 16px;
  color: #0e3f62;
`;

const StyledSwitch = styled.div`
  display: flex;
  align-items: center;
`;

const SwitchText = styled.span`
  font-size: 12px;
  color: #0e3f62;
`;

interface ReportsListProps {
  availableReportList: ReportView[] | null;
  enabledReportIds: string[];
  handleSwitch: (id: string) => void;
}

const ReportTable = ({ availableReportList, enabledReportIds, handleSwitch }: ReportsListProps) => {
  const reportListItems = useMemo(() => availableReportList && availableReportList.length ? availableReportList.map((value) => {
    const reportName = value.name;
    const reportId = value.reportId;
    const isChecked = enabledReportIds.includes(reportId);
    return (
      <Item key={reportId}>
        <Text>
          {reportName}
        </Text>
        <StyledSwitch>
          {isChecked ? <SwitchText>DISPLAY</SwitchText> : <SwitchText>HIDE</SwitchText>}
          <Switch checked={isChecked} onClick={() => handleSwitch(reportId)} />
        </StyledSwitch>
      </Item>
    );
  }) : [], [availableReportList, enabledReportIds]);

  return (
    <Container>
      {reportListItems}
    </Container>
  );
};

export default ReportTable;
